/**
 * Sayfa erişim kataloğu — grup (Role.pages) sayfa anahtarları.
 * API tarafındaki PAGE_KEYS (apps/api/src/pages.ts) ile senkron tutulur.
 * Sıra: yetkisiz sayfadan yönlendirmede İLK izinli sayfa bu sıradan seçilir.
 */
export interface PageDef {
  key: string;
  label: string;
  /** Yönlendirme hedefi (grubun ilk izinli sayfası). */
  path: string;
}

export const PAGES: PageDef[] = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard" },
  { key: "items", label: "Kartlar (Stok / Yarı Mamul / Mamul)", path: "/items/stock" },
  { key: "inventory", label: "Stok / Lotlar", path: "/inventory" },
  { key: "orders", label: "Siparişler", path: "/orders" },
  { key: "production", label: "Üretim", path: "/production" },
  { key: "tuketim-beyani", label: "Tüketim Beyanı", path: "/tuketim-beyani" },
  { key: "qc", label: "Kalite Kontrol", path: "/qc" },
  { key: "maintenance", label: "Bakım / Onarım", path: "/maintenance" },
  { key: "depo-yonetimi", label: "Depo Yönetimi", path: "/depo-yonetimi" },
  { key: "forms", label: "Formlar", path: "/formlar" },
  { key: "projects", label: "Projeler", path: "/projeler" },
  { key: "personel", label: "Personel / İK", path: "/personel" },
  { key: "shipments", label: "Sevkiyat", path: "/shipments" },
  { key: "mrp", label: "MRP / Planlama", path: "/mrp" },
  { key: "purchasing", label: "Satınalma", path: "/purchasing" },
  { key: "companies", label: "Cariler", path: "/companies" },
  { key: "parties", label: "Tedarikçiler / Müşteriler", path: "/parties/suppliers" },
  { key: "locations", label: "Lokasyonlar", path: "/locations" },
  { key: "recipes", label: "Reçeteler", path: "/recipes" },
  { key: "certificates", label: "Sertifikalar", path: "/certificates" },
  { key: "users", label: "Kullanıcılar", path: "/users" },
  { key: "settings", label: "Ayarlar", path: "/settings" },
];

export const PAGE_LABEL: Record<string, string> = Object.fromEntries(PAGES.map((p) => [p.key, p.label]));

/** Kullanıcının erişebildiği ilk sayfanın yolu (katalog sırasına göre); hiç yoksa null. */
export function firstAllowedPath(pages: string[]): string | null {
  const set = new Set(pages);
  const first = PAGES.find((p) => set.has(p.key));
  return first ? first.path : null;
}
